import React, { useRef } from "react";
import { ColorBox, LongBox, ShortBox, TextBox, Wrapper } from "./style";
import { useScrollFadeIn } from "hooks/useScrollFadeIn";
const Com3 = ({ t }) => {
  const ref1 = useRef();
  const ref2 = useRef();

  useScrollFadeIn(ref1, ref2);
  return (
    <Wrapper>
      <TextBox ref={ref1} className="fade-in">
        <span>{t("3-1")}</span>
        <span>
          {}
          <span>{t("3-2")}</span>
          <span>{t("3-3")}</span>
        </span>
      </TextBox>
      <ColorBox ref={ref2} className="fade-in">
        <LongBox>Gradation</LongBox>
        <ShortBox color="#5C5CE5">#5C5CE5</ShortBox>
        <ShortBox color="#34D2F1">#34D2F1</ShortBox>
        <ShortBox color="#71FA4C">#71FA4C</ShortBox>
        <ShortBox color="#F958D1">#F958D1</ShortBox>
        <ShortBox color="#FFFFFF" fontColor={true}>
          #FFFFFF
        </ShortBox>
        <ShortBox color="#000000" border={true}>
          #000000
        </ShortBox>
      </ColorBox>
    </Wrapper>
  );
};

export default Com3;
